import React, { useRef, useState } from 'react';
import { saveAs } from '@progress/kendo-file-saver';
import { drawDOM, exportPDF } from '@progress/kendo-drawing';
import CommonBannerComponent from '../common/CommonBannerComponent';
import WasteCollectionTable from '../components/WasteCollectionTable';
import { useLocation, useNavigate } from 'react-router-dom';
import { Spin } from 'antd';
import { connect } from 'react-redux';
import { getDataFromSessionStorage } from '../utils/utils';
import CustomButton from '../common/CustomButton';
import { useTranslation } from 'react-i18next';

const WasteCalender = (props) => {
  const { loading, themeSettingsData } = props;
  const calenderCollectionData = getDataFromSessionStorage('calenderCollectionData');
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { state } = useLocation();
  const [pdfLoading, setLoading] = useState(false);
  const [footerDesc, setFooterDesc] = useState([]);
  const footerDescription = footerDesc.join('<br/>');
  console.log('🚀 ~ file: WasteCalender.jsx:20 ~ WasteCalender ~ footerDescription:', footerDescription);
  const canvasRef = useRef(null);
  const isSafari = () => {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  };
  const downloadPdf = (dataUri) => {
    // Convert Data URI to a Blob
    const byteString = atob(dataUri.split(',')[1]);
    const mimeString = dataUri.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([ab], { type: mimeString });

    // Create an object URL for the blob
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'CollectionDay.pdf';
    document.body.appendChild(a); // Safari requires the link to be in the body
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const exportPDFWithMethod = async () => {
    setLoading(true);

    try {
      const group = await drawDOM(canvasRef.current, {
        paperSize: 'auto',
        margin: { left: '4cm', top: '3cm', right: '4cm', bottom: '3cm' },
        padding: { left: '4cm', top: '3cm', right: '4cm', bottom: '3cm' },
      });
      const dataUri = await exportPDF(group, {});
      // const response = await fetch(dataUri);
      // const blob = await response.blob();
      // const pdfUrl = window.URL.createObjectURL(blob);
      if (isSafari()) {
        downloadPdf(dataUri);
        // Open the PDF in a new tab on Safari
      } else {
        // Use the saveAs function for non-Safari browsers
        saveAs(dataUri, 'CollectionDay.pdf');
      }
    } catch (error) {
      console.error('Error exporting PDF', error);
    }

    setLoading(false);
  };

  const topBackClick = () => {
    navigate('/collection-day');
  };

  return (
    <div>
      {loading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
          <Spin />
        </div>
      ) : (
        <>
          <div className="container-xxl mt-3">
            <div className="d-flex align-items-center">
              <div className="me-2" style={{ color: '#1F70B8', fontSize: '20px' }}>{`< `}</div>
              <CustomButton themeSettingsData={themeSettingsData} onClick={topBackClick} disable={false}>
                {` ${t('back')}`}
              </CustomButton>
            </div>
          </div>
          <div ref={canvasRef} id="myCanvas">
            <CommonBannerComponent header={calenderCollectionData?.P_CAL_TITLE} subTitle={`${t('collectionFor')} ${state?.label}`} isFormHeader={true} />
            <h5 className="container-xxl text-secondary">{calenderCollectionData?.P_CAL_HEADER_TEXT}</h5>

            {calenderCollectionData?.COLLECTION === null ? (
              <div className="container-xxl">
                <div className="govuk-warning-text mt-5">
                  <span className="govuk-warning-text__icon" aria-hidden="true">
                    !
                  </span>
                  <strong className="govuk-warning-text__text">
                    <span className="govuk-visually-hidden">{t('warning')}</span>
                    {t('noCollectionWarning')}
                  </strong>
                </div>
              </div>
            ) : (
              <WasteCollectionTable calenderCollectionData={calenderCollectionData} setFooterDesc={setFooterDesc} />
            )}
            <h5 className="container-xxl text-secondary">{calenderCollectionData?.P_CAL_FOOTER_TEXT}</h5>
            {/* <h5 className="container-xxl text-secondary" dangerouslySetInnerHTML={{ __html: footerDescription }} /> */}
          </div>
          <div className="container-xxl tableButton">
            {calenderCollectionData?.COLLECTION === null ? (
              ''
            ) : (
              <button className="govuk-button mt-4" data-module="govuk-button" onClick={exportPDFWithMethod} disabled={pdfLoading}>
                {t('downloadCalendar')}
              </button>
            )}
          </div>
          <div className="container-xxl">
            <div className="d-flex align-items-center">
              <div className="me-2" style={{ color: '#1F70B8', fontSize: '20px' }}>{`< `}</div>
              <CustomButton themeSettingsData={themeSettingsData} onClick={topBackClick} disable={false}>
                {` ${t('back')}`}
              </CustomButton>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
const mapStateToProps = ({ calenderData, themeSlice }) => {
  const { themeSettingsData } = themeSlice;
  const { loading, calenderCollectionData } = calenderData;
  return { loading, calenderCollectionData, themeSettingsData };
};

const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(WasteCalender);
